export const GET_GROUPS = 'groups/GET_GROUPS';
export const GET_GROUPS_SUCCESS = 'groups/GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILED = 'groups/GET_GROUPS_FAILED';
export const CREATE_GROUP = 'groups/CREATE_GROUP';
export const CREATE_GROUP_SUCCESS = 'groups/CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILED = 'groups/CREATE_GROUP_FAILED';